@import 'common/component';
@import 'forms/reset/textarea';

:host {
  display: block;
}

@import 'forms/custom/o2-input-group';
@import 'forms/custom/o2-label';
@import 'forms/custom/o2-input';

// textarea override
.o2-input {
  min-height: 8rem;
  resize: vertical;
  height: auto;
}

.o2-input {
  &::-webkit-resizer {
    // textarea-resizer.svg
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMzUzNTUgMC42NDY0NDdDNS41NDg4MiAwLjg0MTcwOSA1LjU0ODgyIDEuMTU4MjkgNS4zNTM1NSAxLjM1MzU1TDEuMzUzNTUgNS4zNTM1NUMxLjE1ODI5IDUuNTQ4ODIgMC44NDE3MDkgNS41NDg4MiAwLjY0NjQ0NyA1LjM1MzU1QzAuNDUxMTg0IDUuMTU4MjkgMC40NTExODQgNC44NDE3MSAwLjY0NjQ0NyA0LjY0NjQ1TDQuNjQ2NDUgMC42NDY0NDdDNC44NDE3MSAwLjQ1MTE4NCA1LjE1ODI5IDAuNDUxMTg0IDUuMzUzNTUgMC42NDY0NDdaIiBmaWxsPSIjMDIwNjE3Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4zNTM1NSAzLjY0NjQ1QzUuNTQ4ODIgMy44NDE3MSA1LjU0ODgyIDQuMTU4MjkgNS4zNTM1NSA0LjM1MzU1TDQuMzUzNTUgNS4zNTM1NUM0LjE1ODI5IDUuNTQ4ODIgMy44NDE3MSA1LjU0ODgyIDMuNjQ2NDUgNS4zNTM1NUMzLjQ1MTE4IDUuMTU4MjkgMy40NTExOCA0Ljg0MTcxIDMuNjQ2NDUgNC42NDY0NUw0LjY0NjQ1IDMuNjQ2NDVDNC44NDE3MSAzLjQ1MTE4IDUuMTU4MjkgMy40NTExOCA1LjM1MzU1IDMuNjQ2NDVaIiBmaWxsPSIjMDIwNjE3Ii8+Cjwvc3ZnPgo=');
    background-repeat: no-repeat;
    background-size: 1.2rem;
  }
}
